import React from 'react';

export default function AutoLoan() {
  return (
    <div>
      <p data-test="footnotes"><strong>Footnotes:</strong></p>
      <ol>
        <li>
          Weighted averages are weighted
          by the Reporting Period Ending Loan Amount. Weighted average
          FICO calculation excludes loans for which a FICO is unavailable.
        </li>
        <li>
          According to the <a href="https://www.sec.gov/info/edgar/specifications/absxml.htm" target="_blank">EDGAR ABS XML Technical Specifications</a>,
          Level 3 employment verification requires direct independent
          verification with a third party of the obligor’s current employment.
        </li>
        <li>
          According to the <a href="https://www.sec.gov/info/edgar/specifications/absxml.htm" target="_blank">EDGAR ABS XML Technical Specifications</a>,
          Level 4 income verification requires previous year W-2 or
          tax returns, and year-to-date pay stubs, if salaried.
          If self-employed, then obligor provided 2 years of tax returns;
          Level 5 income verification requires 24 months income verification
          (W-2s, pay stubs, bank statements and/or tax returns).
          If self-employed, then obligor provided 2 years tax returns
          plus a CPA certification of the tax returns.
        </li>
      </ol>

      <p data-test="disclaimer"><strong>Disclaimer:</strong></p>
      <p>
        This report is an unofficial summary and is offered
        solely as a courtesy service to current and potential customers
        of Finsight Group Inc. We make no warranties, expressed or
        implied, regarding the accuracy of the information
        contained herein. For the most up to date information,
        please view the source material from the SEC’s EDGAR website.
        Information contained herein is not a solicitation or
        recommendation to buy, sell or hold securities.
        Finsight is not offering securities for sale.
        In addition, nothing contained in this report creates any
        contract or right of action against Finsight.
      </p>
      <p>© Finsight Group Inc { new Date().getFullYear() }</p>
    </div>
  );
}
